import { cn } from "@/lib/utils";
import { useAiContextStore } from "@/store/zustand/aiContextStore";
import { Loader2 } from "lucide-react";
import React from "react";
import { Button } from "../ui/button";

export interface Props {
  storyboardId: string;
  small: boolean;
}

export const StoryboardPlaceholderControls = React.memo(({ small }: Props) => {
  const generatingStoryboardIds = useAiContextStore(
    (state) => state.generatingStoryboardIds
  );

  return (
    <>
      <Button
        variant="primary"
        disabled={true}
        className={cn(
          "h-7 rounded-md px-3 flex items-center gap-1.5",
          small && "px-1.5 w-7",
          // Only show if generating
          !generatingStoryboardIds?.size && "hidden"
        )}
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className={cn("animate-spin mr-1")}>
          <Loader2 className="h-4 w-4" />
        </div>
        <span className={cn(small && "hidden")}>Generating</span>
      </Button>
    </>
  );
});
